import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, BookOpenIcon, ShieldAlertIcon, ListOrderedIcon, CheckCircleIcon, ClipboardIcon, AwardIcon, TargetIcon, PrinterIcon } from 'lucide-react';
export function ClassDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const displayName = slug?.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') || 'Class';
  return <div className="space-y-8 max-w-3xl" data-id="element-1922" data-mp="2w1akn1ued8mk">
      <Link to="/student/my-classes" className="inline-flex items-center gap-1.5 text-sm text-purple-700 hover:text-purple-900 transition-colors" data-id="element-1923" data-mp="30yatfkimsphd">
        <ArrowLeftIcon className="h-4 w-4" data-id="element-1924" data-mp="2r7y8hr6wmuap" />
        Back to My Classes
      </Link>

      {/* Course Header Banner */}
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1925" data-mp="3exirga325rjz">
        <div className="flex items-center gap-2 mb-1" data-id="element-1926" data-mp="3jpts5f5mhhdl">
          <BookOpenIcon className="h-5 w-5 text-yellow-300" data-id="element-1927" data-mp="1i9bagq0djss9" />
          <span className="text-purple-200 text-xs font-semibold uppercase tracking-wider" data-id="element-1928" data-mp="1i7grhh8nyaqt">
            On-Demand Class
          </span>
        </div>
        <h1 className="text-2xl font-extrabold tracking-tight" data-id="element-1929" data-mp="1r36j480pg1cn">
          {displayName}
        </h1>
      </div>

      {/* Course Description Card */}
      <div className="rounded-xl overflow-hidden border border-slate-200 shadow-sm" data-id="element-1930" data-mp="1m9lgu3s2wl7n">
        <div className="px-4 py-3 flex items-center gap-2" style={{
        backgroundColor: '#4A2D8F'
      }} data-id="element-1931" data-mp="212f9ys09wzus">
          <BookOpenIcon className="h-4 w-4 text-yellow-300 flex-shrink-0" data-id="element-1932" data-mp="2a1ai49mvok0q" />
          <p className="text-white text-xs font-bold" data-id="element-1933" data-mp="25zovhwkjkrdc">About This Course</p>
        </div>
        <div className="bg-white px-5 py-4" data-id="element-1934" data-mp="fmzrbvmq3fsb">
          <p className="text-sm text-slate-700 leading-relaxed" data-id="element-1935" data-mp="fo11zyztu09i">
            This class will review the way real estate agency representation is
            provided in Arizona, how licensees are obligated to disclose their
            agency to the clients, and the various means of representing
            clients. Dual agency, exclusive agency, implied agency and
            facilitation will be reviewed.
          </p>
        </div>
      </div>

      {/* Identity Verification Warning */}
      <div className="flex items-start gap-3 rounded-xl border-2 border-amber-400 bg-amber-50 px-5 py-4" data-id="element-1936" data-mp="2pogdw48kj8xb">
        <ShieldAlertIcon className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-1937" data-mp="2to8qqt4zw18h" />
        <div data-id="element-1938" data-mp="2ynbjbe3sgezk">
          <p className="text-sm font-extrabold text-amber-800 uppercase tracking-wide mb-1" data-id="element-1939" data-mp="2ymse8xz8ll2y">
            Identity Verification Required
          </p>
          <p className="text-sm text-amber-900 leading-relaxed" data-id="element-1940" data-mp="38dwsfvh391wq">
            The Arizona Department of Real Estate requires that we confirm your
            identity and that you are the person taking the classes.
            Impersonating a real estate licensee is a felony in the State of
            Arizona and will be subject to a real estate forfeiture for either
            or both parties. If you are NOT the person named in the
            registration, we strongly recommend that you log out and not
            continue. We reserve the right to use reasonable means to verify
            your identity.
          </p>
        </div>
      </div>

      {/* Course Requirements */}
      <div data-id="element-1941" data-mp="rtt3q8rs14dt">
        <div className="flex items-center gap-2 mb-4" data-id="element-1942" data-mp="1pf8loxcgo9c1">
          <ListOrderedIcon className="h-5 w-5" style={{
          color: '#4A2D8F'
        }} data-id="element-1943" data-mp="1pep3rgmt9ky0" />
          <h2 className="text-lg font-extrabold" style={{
          color: '#4A2D8F'
        }} data-id="element-1944" data-mp="1fpfbo0ryw29w">
            Course Details
          </h2>
        </div>

        <div className="space-y-3" data-id="element-1945" data-mp="1aohrxjrb706a">
          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1946" data-mp="285zqdlli7bk3">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-1947" data-mp="23dyjkf73ud1g">
              <ClipboardIcon className="h-4 w-4" data-id="element-1948" data-mp="1rwh4xldsheq4" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1949" data-mp="1e03wt2v5apob">
              <span className="font-bold text-slate-900" data-id="element-1950" data-mp="1ixncm77hraid">5 sections</span> to
              complete in this course
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1951" data-mp="26nzt46gsyfkk">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-1952" data-mp="2bm1cksi54gwk">
              <BookOpenIcon className="h-4 w-4" data-id="element-1953" data-mp="2pmluznk58apj" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1954" data-mp="2pl0wxnyme9mx">
              <span className="font-bold text-slate-900" data-id="element-1955" data-mp="2udbz6xgu27in">Take NOTES:</span> You
              can print pages or copy & paste for your notes
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1956" data-mp="dz06qoj4ppd5">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-1957" data-mp="rq5c8796hbve">
              <CheckCircleIcon className="h-4 w-4" data-id="element-1958" data-mp="jnlb9lij3" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1959" data-mp="3r620ybltp8d6">
              <span className="font-bold text-slate-900" data-id="element-1960" data-mp="3r7lg1yvqtddd">Review anytime.</span>{' '}
              You can review the material at any time throughout the course
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1961" data-mp="3zhpifulshos">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#E8A020'
          }} data-id="element-1962" data-mp="1kh5i6nr2kppp">
              <TargetIcon className="h-4 w-4" data-id="element-1963" data-mp="i14v9t4ufprc" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1964" data-mp="i3hcu56ovy3v">
              <span className="font-bold text-slate-900" data-id="element-1965" data-mp="m4ay0qsqyyt2">
                100% to pass each quiz
              </span>{' '}
              in order to proceed to the next section
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1966" data-mp="3qirdr9yuexa2">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#E8A020'
          }} data-id="element-1967" data-mp="3ujkxdr595px5">
              <AwardIcon className="h-4 w-4" data-id="element-1968" data-mp="36tgz7zau2idj" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1969" data-mp="36t75q1qkxt33">
              <span className="font-bold text-slate-900" data-id="element-1970" data-mp="3bs1ztztzz42i">
                80% to pass the final.
              </span>{' '}
              The final is a compilation of the quiz questions you have already
              answered
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1971" data-mp="2z7va7zk1klel">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#2E7D32'
          }} data-id="element-1972" data-mp="2ucpob0qn36qi">
              <PrinterIcon className="h-4 w-4" data-id="element-1973" data-mp="2gj6s1lcy0u6i" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1974" data-mp="2bkdclne3it3p">
              <span className="font-bold text-slate-900" data-id="element-1975" data-mp="2bkwsyzo3l9fm">
                Certificate date stamped
              </span>{' '}
              upon completion of your final. If you'd like to remain paperless,
              click "Print Certificate" to download a PDF. Save in a folder for{' '}
              <strong className="text-base" data-id="element-1976" data-mp="1xlx5hvcbn0l1">5</strong> years (per ADRE rules)
            </div>
          </div>
        </div>
      </div>

      {/* Your Class Button */}
      <div className="flex justify-center pt-2" data-id="element-1977" data-mp="3qg4y3f533vaf">
        <Link to={`/student/class/${slug}/content`} className="inline-block px-14 py-3.5 text-white text-lg font-extrabold rounded-lg transition-all hover:scale-[1.02] shadow-md text-center" style={{
        backgroundColor: '#CC0000'
      }} data-id="element-1978" data-mp="3qflnykloeb6y">
          Your Class
        </Link>
      </div>
    </div>;
}